export enum VendorQuoteAttachToType {
  COSTING_PROFILE = 'costing_profile',
  JOB = 'job',
  PROJECT = 'project',
  QUOTE = 'quote',
}

// Extractor → vendor mapping state reported by the progress poll. The FE branches on this value
// alone and never recomputes it; the values stay snake_case because only response KEYS are
// camel-cased on the way in.
export enum VendorMappingState {
  MAPPED = 'mapped',
  NO_EXTRACTOR = 'no_extractor',
  NOT_APPLICABLE = 'not_applicable',
  UNMAPPED = 'unmapped',
}

// Outcome of the vendor-quote duplicate check the gated (Attributes) import runs before the wizard.
export enum VendorQuoteDuplicateOutcome {
  CANCELED = 'canceled',
  NONE = 'none',
  REUSED = 'reused',
}
